import { Box, Button, Card, CardContent, CardMedia, Container, Grid, makeStyles, Typography } from "@material-ui/core";
import territory from '../../../assets/image/slick/territory-tab-desktop.webp';
import { useEffect, useState } from "react";
import GoogleSheetsService from "../../../services/GoogleSheetsService";
import { Link } from 'react-router-dom';
const TerritoryNew = () => {
    const classes = useStyles();
    const [territoryData, setTerritoryData] = useState([]);
    useEffect(() => {
        const fetchData = async (sheetName) => {
            try {
                const data = await GoogleSheetsService.getData(sheetName, 'A:H');
                setTerritoryData(data);
            } catch (err) {
            }
        };

        fetchData('territory');
    }, []);

    return (
        <Box>
            <div className={classes.root}>
                <div className={classes.slide}>
                    <img src={territory} className={classes.image} />
                    <Box className={classes.overlay}>
                        <Typography variant="h2" className={classes.title}>
                            Ford Territory Mới
                        </Typography>
                        <Typography variant="h4" className={classes.title}>
                            Đi Tới Trải Nghiệm Mới
                        </Typography>
                        <Button variant="contained" className={classes.exploreButton}>
                            Đăng ký lái thử
                        </Button>
                    </Box>
                </div>
            </div>
            <Container maxWidth="md" className={classes.container}>
                <Box>
                    <Typography variant="h1" className={classes.title21} >
                        Mừng Lễ Lớn Cùng Ford
                    </Typography>
                    <Typography variant="h1" className={classes.title22} >
                        Du Ngoạn Muôn Nơi
                    </Typography>
                </Box>
                <Box>
                    <img className={classes.image2Web} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/retail-ford-territory-sept-desktop.webp" />
                </Box>
            </Container>
            <Box className={classes.box3}>
                <img className={classes.image3Web} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/territory-collage-image.webp" />
                <img className={classes.image3Mob} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/territory-collage-image-mbl.webp" />
            </Box>
            <Container maxWidth="lg" className={classes.container}>
                <Box>
                    <Typography variant="h1" className={classes.title21} >
                        Thiết kế hiện đại, sắc sảo, đầy cuốn hút
                    </Typography>
                </Box>               
            </Container>
            <Box>
                <Grid container className={classes.gird4}>
                    <Grid item xs={12} md={1} ></Grid>
                    <Grid item xs={12} md={10} >
                        <Box >
                            <img className={classes.image3WebNew} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/exterior-1-desktop.webp" />
                            <img className={classes.image3WebNew} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/exterior-2-desktop.webp" />
                            <img className={classes.image3WebNew} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/exterior-3-desktop.webp" />
                            <img className={classes.image3MobNew} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/exterior-1-mobile.webp" />
                            <img className={classes.image3MobNew} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/exterior-2-mobile.webp" />
                            <img className={classes.image3MobNew} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/exterior-3-mobile.webp" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={1} ></Grid>
                </Grid>
            </Box>
            <Container maxWidth="lg" className={classes.container}>
                <Box>
                    <Typography variant="h1" className={classes.title21} >
                        Không gian nội thất rộng rãi, tiện nghi
                    </Typography>
                </Box>               
            </Container>
            <Box className={classes.box3}>
                <img className={classes.image3Web} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/territory-gallery-2.webp" />
                <img className={classes.image3Mob} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/territory-gallery-2-mob.webp" />
            </Box>
            <Container maxWidth="lg" className={classes.container}>
                <Box>
                    <Typography variant="h1" className={classes.title21} >
                        Đem đến trải nghiệm lái tuyệt vời
                    </Typography>
                </Box>
                <Grid container className={classes.gird4}>
                    <Grid item xs={12} md={8} >
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.image4Web} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/cards/territory-exterior-image-5.webp" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} >
                        <Box className={classes.boxParent4}>
                            <Box className={classes.boxChild4}>
                                <Typography variant="h3" className={classes.typo4}>
                                    Tận hưởng mọi hành trình với khả năng vận hành mượt mà, êm ái
                                </Typography>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                       1.5L
                                    </Typography>
                                    <Typography variant="h6"  >
                                        Động cơ EcoBoost
                                    </Typography>
                                </Box>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        160Ps
                                    </Typography>
                                    <Typography variant="h6"  >
                                        Công suất cực đại
                                    </Typography>
                                </Box>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        7 cấp
                                    </Typography>
                                    <Typography variant="h6"  >
                                        Hộp số tự động
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth="lg" className={classes.container}>
                <Box>
                    <Typography variant="h1" className={classes.title21} >
                        Tính năng an toàn tối đa cho gia đình
                    </Typography>
                </Box>               
            </Container>
            <Box className={classes.box3}>
                <img className={classes.image3Web} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/territory-gallery-3-desktop.webp" />
                <img className={classes.image3Mob} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/billboards/territory-gallery-3-mobile.webp" />
            </Box>

            <Container maxWidth="lg" className={classes.container}>
                <Box>
                    <Typography variant="h1" className={classes.title21} >
                        Công nghệ hiện đại không giới hạn
                    </Typography>
                    <Typography variant="h1" className={classes.title22} >
                        Giúp bạn tận hưởng mọi hành trình
                    </Typography>
                </Box>
                <Grid container className={classes.gird4}>
                    <Grid item xs={12} md={8} >
                        <Box height="100%" className={classes.boxImg4}>
                            <img className={classes.image4Web} src="https://www.ford.com.vn/content/dam/Ford/vn/nameplate/territory/overview/cards/interior-2.webp" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} >
                        <Box className={classes.boxParent4}>
                            <Box className={classes.boxChild4}>
                                <Typography variant="h3" className={classes.typo4}>
                                    Công nghệ hiện đại không giới hạn
                                </Typography>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        12.3"
                                    </Typography>
                                    <Typography variant="h6"  >
                                        Màn hình cảm ứng
                                    </Typography>
                                </Box>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        Apple CarPlay™ & Android Auto™
                                    </Typography>
                                    <Typography variant="h6"  >
                                        Kết nối không dây
                                    </Typography>
                                </Box>
                                <Box className={classes.box4}>
                                    <Typography variant="h3"  >
                                        Điều hòa tự động
                                    </Typography>
                                    <Typography variant="h6"  >
                                        với chức năng lọc không khí
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth="xl" className={classes.container6}>
                <Box>
                    <Typography variant="h1" className={classes.title22} >
                        Các Mẫu Xe Ford Territory
                    </Typography>
                </Box>
                <Grid container className={classes.gird4}>
                    {territoryData.map((xe, index) => (
                        <Grid item key={index} xs={12} md={3} className={classes.gridDanhSach}>
                            <Box className={classes.box6}>
                                <Box className={classes.box6Image}>
                                    <img className={classes.box6ImageChild} src={xe.anhdanhsach} />
                                </Box>

                                <Box className={classes.box6NoiDung}>
                                    <Typography variant="h4" className={classes.title6} >
                                        {xe.ten}
                                    </Typography>
                                    <Typography variant="h6" className={classes.noiDung6}>
                                        {xe.motangan}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Button variant="contained" className={classes.button6} >
                                        <Link to={`/chi-tiet/territory/${xe.tenLink}`} className={classes.link}>
                                            Tìm hiểu thêm
                                        </Link>
                                    </Button>
                                    <Button variant="outlined" href={`/bao-gia/${xe.tenLink}`} className={classes.button61}>
                                        Báo giá
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box >
    );
};
export default TerritoryNew;

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: '100%', // Đảm bảo slider chiếm hết chiều rộng container
        margin: '0 auto', // Căn giữa slider nếu cần
    },
    image: {
        display: 'block',
        width: '100%',
        height: 'auto',
    },
    overlay: {
        position: 'absolute', // Định vị tuyệt đối
        bottom: theme.spacing(5), // Cách đáy một khoảng
        left: theme.spacing(10), // Cách lề trái một khoảng
        color: 'white', // Màu chữ trắng
        padding: theme.spacing(2),
        zIndex: 1, // Đảm bảo overlay nằm trên ảnh
    },
    title: {
        marginBottom: theme.spacing(1),
    },
    exploreButton: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    container: {
        marginTop: theme.spacing(8),
    },
    title21: {
        fontSize: '3rem', // Kích thước chữ lớn
        fontWeight: 'bold',
        marginBottom: theme.spacing(2), // Khoảng cách dưới tiêu đề
        color: '#066fef !important'
    },
    title22: {
        fontSize: '3rem', // Kích thước chữ lớn
        fontWeight: 'bold',
        marginBottom: theme.spacing(2), // Khoảng cách dưới tiêu đề
        color: '#00095b !important'
    },
    image2Web: {
        width: '100%',
        borderRadius: '10px'
    },
    box3: {
        marginTop: theme.spacing(15),
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(8),
        }
    },
    image3Web: {
        width: '100%',
        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    },
    image3Mob: {
        width: '100%',
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    gird4: {
        marginTop: theme.spacing(10),
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(4),
        },
        display: 'flex', // Sử dụng flexbox cho container của grid
        alignItems: 'stretch',
    },
    boxParent4: {
        backgroundColor: 'rgb(6, 111, 239)',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // Chiếm toàn bộ chiều cao của grid item
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(2),
        }
    },
    boxChild4: {
        padding: theme.spacing(4)
    },
    box4: {
        marginTop: theme.spacing(4),
        color: '#fff'
    },
    typo4: {
        color: '#fff'
    },
    boxImg4: {
        borderRadius: '10px',
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
            marginRight: theme.spacing(2),
        }
    },
    image4Web: {
        display: 'block',
        width: '100%',
        height: '100%', // Ảnh lấp đầy container
        objectFit: 'cover',  // Đảm bảo ảnh không bị méo
    },
    box6Image: {
        borderRadius: '10px',
        textAlign: 'center',
        '&:hover $box6ImageChild': {
            transform: 'scale(1.1)'
        },
        overflow: 'hidden'
    },
    box6ImageChild: {
        transition: 'transform 0.3s ease-in-out',
        borderRadius: '10px',
    },
    title6: {
        fontWeight: 'bold',
        marginTop: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(1),
        },
        marginBottom: theme.spacing(2),
        color: '#00095b !important'
    },
    box6NoiDung: {
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
        },

    },
    noiDung6: {
        fontSize: '1pc',

    },
    button6: {
        backgroundColor: '#1976d2',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#1565c0',
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
    },
    button61: {
        borderColor: '#1976d2',
        color: '#1976d2',
        '&:hover': {
            backgroundColor: '#1565c0',
            color: '#fff',
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
            marginTop: theme.spacing(2),
        },
    },
    box6: {
        [theme.breakpoints.down('md')]: {
            marginBottom: theme.spacing(5),
        },
    },
    container6: {
        marginTop: theme.spacing(10),
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    },
    image3WebNew: {
        width: '100%',
        [theme.breakpoints.down('md')]: {
            display: 'none'
        },
        padding: '30px 60px 30px 60px',
        borderRadius: '10px'
    },
    image3MobNew: {
        width: '100%',
        [theme.breakpoints.up('md')]: {
            display: 'none'
        },
        padding: '10px 30px 10px 30px',
        borderRadius: '10px'
    }
}));